import React, { useState, useRef, useEffect } from "react";
import { Link, Navigate, useNavigate, useParams } from "react-router-dom";

import { FiChevronLeft, FiUser } from "react-icons/fi";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../redux/features/authHandler.feature";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FacebookLogin from "@greatsumini/react-facebook-login";
import InputPassword from "../components/InputPassword.component";
import Cookies from "js-cookie";
import Button from "../components/elements/Button.component";

// images
import logo from "../assets/images/logo-circle.png";
import googleLogo from "../assets/images/google.png";
import fbLogo from "../assets/images/facebook.png";
import GoogleLogin from "@caranmegil/react-google-login";
import { AiOutlineMail } from "react-icons/ai";

export default function Signin() {

  const { id } = useParams();

  const [wizardKey, setWizardKey] = useState("0");
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [flag, setFlag] = useState("");

  const emailFormik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().email().required("Required"),
    }),
    onSubmit: async (values) => {
      await fetch(`${process.env.REACT_APP_BASE_URL}/api/email_sent`, {
        method: "POST", 
        headers: {
          "content-type" : "application/json"
        }, 
        body: JSON.stringify({
          email: values.email, 
          redirect_link: "http://localhost:3000/verifying"
        })
      })
      .then(r => r.json())
      .then(response => {
        if(response.success){
          setFlag({
            type: "success", 
            message: response.message
          });
        } else {
          setFlag({
            type: "error", 
            message: response.message
          });
        }
      })
    },
  });

  
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().email().required("Required"),
      password: Yup.string()
        .min(3, "Must be 3 characters or less")
        .required("Required"),
    }),
    onSubmit: async (values) => {
      // send login data to server here
      // console.log(values);
      setFlag("loading");
      // registering user online
      await fetch(`${process.env.REACT_APP_BASE_URL}/api/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email: values.email,
          password: values.password,
        }),
      })
        .then((r) => r.json())
        .then((response) => {
          // console.log(response);
          if (response.success) {
            fetch(`${process.env.REACT_APP_BASE_URL}/api/get_profile`, {
              method: "GET",
              headers: {
                Authorization: `Bearer ${response.records.token}`,
              },
            })
              .then((r) => r.json())
              .then((res) => {
                setFlag("");
                if (res.success) {

                  toast.success("Login Success", { hideProgressBar: true });
                  let tmp = {};
                  setTimeout(() => {
                    tmp.data = res.records;
                    tmp.token = response.records.token;
                    dispatch(login(tmp));
                    Cookies.set("token", response.records.token);
                    if (response?.records?.role == 3) {
                      return navigate("/create-job", { replace: true });
                    } else {
                      return navigate("/jobs", { replace: true });
                    }
                  }, 2000);
                } else {
                  toast.warn(response.message);
                }
              });
          } else {
            toast.warn(response.message);
          }
        })
        .catch((error) => console.log("Error Found: ", error));
    },
  });

  // Google Login Response
  const responseGoogle = async (response) => {
    console.log(response);
    let email = response.profileObj.email;
    let name = response.profileObj.name;
    // let profile_image = response.profileObj.imageUrl;
    let googleData = new FormData();
    googleData.append("user_name", name);
    googleData.append("email", email);
    googleData.append("role", 3);
    googleData.append("user_type", "google");

    await fetch(`${process.env.REACT_APP_BASE_URL}/api/register_user`, {
      method: "POST",
      body: googleData,
    })
      .then((r) => r.json())
      .then((response) => {
        if (response.success) {
          fetch(`${process.env.REACT_APP_BASE_URL}/api/get_profile`, {
            method: "GET",
            headers: {
              Authorization: `Bearer ${response.records.token}`,
            },
          })
            .then((r) => r.json())
            .then((res) => {
              if (res.success) {
                toast.success("Login Success", { hideProgressBar: true });
                let tmp = {};
                setTimeout(() => {
                  tmp.data = res.records;
                  tmp.token = response.records.token;
                  dispatch(login(tmp));
                  Cookies.set("token", response.records.token);
                  if (response?.records?.role == 3) {
                    return navigate("/create-job", { replace: true });
                  } else {
                    return navigate("/jobs", { replace: true });
                  }
                }, 2000);
              } else {
                toast.warn(response.message);
              }
            });
        } else {
          toast.error(response.message);
        }
      });
  };

  // Facebook Response
  const responseFacebook = async (response) => {
    let email = response.email;
    let name = response.name;
    let facebookData = new FormData();
    facebookData.append("user_name", name);
    facebookData.append("email", email);
    facebookData.append("role", 3);
    facebookData.append("user_type", "facebook");

    await fetch(`${process.env.REACT_APP_BASE_URL}/api/register_user`, {
      method: "POST",
      body: facebookData,
    })
      .then((r) => r.json())
      .then((response) => {
        if (response.success) {
          fetch(`${process.env.REACT_APP_BASE_URL}/api/get_profile`, {
            method: "GET",
            headers: {
              Authorization: `Bearer ${response.records.token}`,
            },
          })
            .then((r) => r.json())
            .then((res) => {
              if (res.success) {
                toast.success("Login Success", { hideProgressBar: true });
                let tmp = {};
                setTimeout(() => {
                  tmp.data = res.records;
                  tmp.token = response.records.token;
                  dispatch(login(tmp));
                  Cookies.set("token", response.records.token);
                  if (response?.records?.role == 3) {
                    return navigate("/create-job", { replace: true });
                  } else {
                    return navigate("/jobs", { replace: true });
                  }
                }, 2000);
              } else {
                toast.warn(response.message);
              }
            });
        } else {
          toast.error(response.message);
        }
      });
  };


  useEffect(() => {
    if(id){
      async function autoLoginUser(){
        await fetch(`${process.env.REACT_APP_BASE_URL}/api/auto_login/${id}`, {
          method: "GET", 
          headers: {
            "content-type": "application/json"
          }
        })
        .then(r => r.json())
        .then(res => {
          if (res.success) {
            toast.success("Login Success", { hideProgressBar: true });
            let tmp = {};
            setTimeout(() => {
              tmp.data = res.records;
              tmp.token = res.records.token;
              dispatch(login(tmp));
              Cookies.set("token", res.records.token);
              if (res?.records?.role == 3) {
                return navigate("/create-job", { replace: true });
              } else {
                return navigate("/jobs", { replace: true });
              }
            }, 2000);
            
          } else {
            toast.warn(res.message);
          }
        })
      }
      autoLoginUser();
    }
  }, []);

  return (
    <main>
      <ToastContainer />
      {/* <!-- login START --> */}
      <div className="bds-loginconatiner">
        <div
          className="bds-popupcontainer"
          style={{ width: "clamp(100%,400px,500px)" }}
        >
          <div className="bds-login_title">
            <Link to="/">
              <img src={logo} className="site-logo" alt="images description" />
            </Link>
            {/* <h5>Welcome! Nice to see you again</h5> */}
          </div>

          <div className="bds-login-content bds-popup-content">
            {wizardKey === "0" ? (
              <form className="bds-themeform" onSubmit={formik.handleSubmit}>
                <div className="bds-themeform__wrap">
                  <div className="form-group flex-column align-items-start">
                    <div
                      className={`bds-placeholderholder px-3 ${
                        formik.touched.email && formik.errors.email
                          ? "border border-danger"
                          : ""
                      }`}
                    >
                      <FiUser />
                      <input
                        name="email"
                        type="email"
                        className={`form-control bds-themeinput`}
                        placeholder="Email Address"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                    </div>
                    <p className="m-0">
                      {formik.touched.email && formik.errors.email ? (
                        <small className="text-danger">
                          {formik.errors.email}
                        </small>
                      ) : null}
                    </p>
                  </div>
                  <div className="form-group flex-column align-items-start">
                    <InputPassword
                      name="password"
                      placeholder="Password"
                      className="form-control bds-themeinput"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      errorclassName={
                        formik.touched.password && formik.errors.password
                          ? "border border-danger"
                          : ""
                      }
                    />
                    <p className="m-0">
                      {formik.touched.password && formik.errors.password ? (
                        <small className="text-danger">
                          {formik.errors.password}
                        </small>
                      ) : null}
                    </p>
                  </div>
                  <div className="bds-popup-terms form-group">
                    <Button
                      type="submit"
                      name="Sign in"
                      isLoading={flag === "loading" ? true : false}
                      className="bds-btn-solid-lg"
                    />
                    {/* <button
                      type="submit"
                      name="submit"
                      className="bds-btn-solid-lg"
                    >
                      Sign in
                    </button> */}
                  </div>
                  <div className="bds-sginup-btn form-group">
                    <button
                      className="bds-btn-line-lefticon btn-signup"
                      onClick={() => setWizardKey("1")}
                    >
                      <AiOutlineMail className="me-2" size={24} />
                      <span className="ms-2">Login in Link</span>
                    </button>
                  </div>
                  <GoogleLogin
                    clientId={`${process.env.REACT_APP_GOOGLE_CLIENT_ID}`}
                    render={(renderProps) => (
                      <div className="bds-sginup-btn form-group">
                        <button
                          className="bds-btn-line-lefticon btn-signup"
                          onClick={renderProps.onClick}
                          disabled={renderProps.disabled}
                        >
                          <img
                            src={googleLogo}
                            alt="images"
                            width={30}
                            height={30}
                          />
                          <span className="ms-2">Signin with Google</span>
                        </button>
                      </div>
                    )}
                    onSuccess={responseGoogle}
                    onFailure={responseGoogle}
                    cookiePolicy={"single_host_origin"}
                  />

                  <FacebookLogin
                    appId={`${process.env.REACT_APP_FACEBOOK_CLIENT_ID}`}
                    onProfileSuccess={(response) => {
                      responseFacebook(response);
                    }}
                    render={({ onClick }) => (
                      // <CustomComponent onClick={onClick} onLogoutClick={logout} />
                      <div className="bds-sginup-btn form-group">
                        <button
                          className="bds-btn-line-lefticon btn-signup"
                          onClick={onClick}
                        >
                          <img
                            src={fbLogo}
                            alt="images"
                            width={30}
                            height={30}
                          />
                          <span className="ms-2">Signin with Facebook</span>
                        </button>
                      </div>
                    )}
                  />

                  {/* Sign up with facebook */}
                  {/* <div className="bds-sginup-btn form-group">
                  <button className="bds-btn-line-lefticon btn-signup">
                    <img
                      src={fbLogo}
                      alt="images"
                      width={30}
                      height={30}
                    />
                    <span className="ms-2">Signup with Facebook</span>
                  </button>
                </div> */}

                  <div className="bds-lost-password form-group">
                    <Link to="/signup">Register an Account</Link>
                    <Link
                      to="/forgot-password"
                      className="bds-password-clr_light"
                    >
                      forgot password?
                    </Link>
                  </div>
                </div>
              </form>
            ) : (
              <>
                <button
                  className="btn btn-link text-decoration-none text-sky-blue d-flex align-items-center p-0 mb-3"
                  onClick={() => setWizardKey("0")}
                >
                  <FiChevronLeft />
                  <span className="ms-1">Back</span>
                </button>
                <h4 className="fw-bold">Login with Link</h4>
                <p className="text-muted">Get a link sent to your email to sign you in instantly</p>
                {
                  Object.keys(flag).length > 0 ? <div className={`text-center ${flag.type == "success" ? "text-success" : "text-danger"}`}>{flag.message}</div> : 
                  <form
                    className="bds-themeform"
                    onSubmit={emailFormik.handleSubmit}
                  >
                    <div
                      className={`bds-placeholderholder px-3`}
                    >
                      <FiUser />
                      <input
                        name="email"
                        type="email"
                        className={`form-control bds-themeinput`}
                        placeholder="Email Address"
                        onChange={emailFormik.handleChange}
                        onBlur={emailFormik.handleBlur}
                      />
                    </div>
                    <div className="bds-popup-terms form-group w-100 px-0 " >
                      <Button
                        type="submit"                      
                        name="Sign in"
                        isLoading={flag === "loading" ? true : false}
                        className="bds-btn-solid-lg"
                      />
                      {/* <button
                        type="submit"
                        name="submit"
                        className="bds-btn-solid-lg"
                      >
                        Sign in
                      </button> */}
                      </div>
                  </form>
                }
              </>
            )}
          </div>
        </div>
      </div>
      {/* <!-- login START --> */}
    </main>
  );
}
